<template>
    <v-app id="inspire">
        <SideNav></SideNav>
        <PageHeader></PageHeader>
        <v-content :style="{'padding-left' : paddingLeft}">
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
    import PageHeader from "./layout/PageHeader";
    import SideNav from "./layout/SideNav";

    export default {
        name: "layout",
        components: {SideNav, PageHeader},
          data() {
            return {
                paddingLeft: '200px'
            }
        },
          methods: {
          
        }
    }
</script>


<style scoped lang="scss">

</style>
